module.exports = () ->
  return {

    restrict: 'A'

    scope:
      model:                  '=inlineEditor'
      isDisabled:             '&inlineEditorIsDisabled'
      onSave:                 '&'
      onFormModification:     '&'
      onFormBlur:             '&'
      starredDocs:            '=?references'
      user:                   '=?inlineEditorUser'
      showGptSummary: '=?'

    controller: ( $scope, $element ) ->
      $scope.editing = false
      $scope.isInlineEditor = true
      $scope.commentOrderId = null
      $scope.commentVisible = false
      $scope.comments = []

      # a hack to bypass ng-ifs child scope
      $scope.obj = {
        model: $scope.model
      }

      $scope.setEditing = ( isEditing )->
        $scope.editing = isEditing

      $scope.save = ()->
        $scope.onSave()
        $scope.setEditing( false )
        $scope.commentVisible = false

      $scope.isModelEmpty = () ->
        if !$scope.model?
          return true
        else
          return $scope.model == ''

      $scope.canAccessComments = () ->
        if $scope.user?
          return $scope.user.hasPermission('workflow.can_add_summary_comments', false)
        return false

      $scope.showComments = () ->
        $scope.commentVisible = true
        $scope.commentOrderId = null
        if !$scope.editing
          $scope.setEditing(true)

      $scope.hideComments = () ->
        $scope.commentVisible = false

      $scope.selectComment = (commentOrderId) ->
        $scope.commentOrderId = commentOrderId

      $scope.onBlur = () ->
        $scope.onFormBlur()

      $scope.$watch 'model', (newValue, oldValue) ->
        comments = []

        angular.forEach $(newValue).find('span[data-annotation-value]'), (el, i) ->
          item =
            orderId: i
            comment: $(el).data('annotation-value')
          comments.push(item)
        if (newValue != oldValue) && $scope.editing
          $scope.onFormModification()
        $scope.comments = comments

    template: require('./inline-editor.html')

  }
